import { render } from "./Contacts copy.vue?vue&type=template&id=7eb84b77&scoped=true"
import script from "./Contacts copy.vue?vue&type=script&lang=js"
export * from "./Contacts copy.vue?vue&type=script&lang=js"

import "./Contacts copy.vue?vue&type=style&index=0&id=7eb84b77&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb84b77"]])

export default __exports__